import { twMerge } from '@panwds/tailwindcss';
import React, { forwardRef } from 'react';
import { useSelectContext } from './SelectProvider.js';
export const SelectFooter = forwardRef(({ className, children }, ref) => {
    const ctx = useSelectContext();
    const listItemSize = ctx.size ?? ctx.listItemSize ?? 'md';
    return (React.createElement("div", { ref: ref, className: twMerge('twds-flex twds-z-30 twds-bg-white dark:twds-bg-gray-1000', listItemSize === 'sm' ? 'twds-p-1' : 'twds-p-2', className) }, children));
});
//# sourceMappingURL=SelectFooter.js.map